import { MaterialCommunityIcons } from "@expo/vector-icons";
import { StyleSheet, Text, View } from "react-native";
import { useTranslation } from "@luna-restaurant/i18n";
import { Icon, ThemedText, useCustomTheme } from "@luna-restaurant/ui";
export const MenuCardHeader = ({ dayNumber, hasCheckmark, invalid, noMenu, }) => {
    const { colors, fonts } = useCustomTheme();
    const { t } = useTranslation();
    const showCheckmark = (hasCheckmark || invalid === false) && !noMenu;
    return (<View style={styles.container}>
      <Text style={[styles.dayNumber, { ...fonts.bold }]}>{dayNumber}</Text>

      {showCheckmark && (<MaterialCommunityIcons name="check-circle" size={24} color={colors.success} style={styles.icon} testID="checkmark-icon"/>)}

      {invalid && (<View style={styles.invalidWrapper}>
          <Icon iconSet="material" icon="notification-important" size={24} color={colors.danger}/>
          <View style={styles.invalidText}>
            <ThemedText type="small" style={{ color: colors.danger }}>
              {t(`menuCard.dayInvalidReasons.${invalid}`)}
            </ThemedText>
          </View>
        </View>)}
    </View>);
};
const styles = StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        height: 48,
        padding: 8,
    },
    dayNumber: {
        fontSize: 24,
        lineHeight: 30,
    },
    icon: {
        padding: 2,
    },
    invalidWrapper: {
        flexDirection: "row",
        alignItems: "center",
        gap: 4,
    },
    invalidText: {
        maxWidth: 160,
    },
});
//# sourceMappingURL=MenuCardHeader.js.map